import React, { useState } from 'react';
import ChatWindow from './ChatWindow';
import { useAuthStore } from '../../store';

export default function ChatButton({ orderRef, style = {} }) {
  const [open, setOpen] = useState(false);
  const { user } = useAuthStore();

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          padding: '7px 14px', borderRadius: 8,
          border: '1px solid #1a4e8c', background: '#eaf1fb',
          fontSize: 12, cursor: 'pointer', fontWeight: 600,
          color: '#1a4e8c', display: 'flex', alignItems: 'center', gap: 6,
          ...style,
        }}>
        💬 Chat
      </button>

      {open && (
        <ChatWindow
          orderRef={orderRef}
          currentUser={user}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
